module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Ga-Hc-Ia.fe1326a9.png";